import React from 'react';
import { IconRender, InheritProps } from '../IconRender';

export function ThreeContentIcon(props: InheritProps) {
  return (
    <IconRender
      {...props}
      childrenRender={(color: string) => (
        <>
        <rect x="1" y="1" width="48" height="78" rx="7" fill="#343434" stroke={color} strokeWidth="4"/>
        <path d="M3.01721 48.0079C3.01795 48.555 2.57502 48.9992 2.02789 49V49L2.00021 28.5574V28.5574C2.54734 28.5566 2.99147 28.9995 2.99222 29.5466L3.01721 48.0079Z" fill="#D9D9D9"/>
        <path d="M46.948 29.5497C46.9454 29.0026 47.3869 28.557 47.934 28.5543V28.5543L48.0296 48.9967V48.9967C47.4825 48.9993 47.0369 48.5579 47.0343 48.0108L46.948 29.5497Z" fill="#D9D9D9"/>
        <rect x="4" y="29" width="13" height="20" rx="1.5" fill="#D9D9D9"/>
        <rect x="18" y="29" width="14" height="20" rx="1.5" fill="#D9D9D9"/>
        <rect x="33" y="29" width="13" height="20" rx="1.5" fill="#D9D9D9"/>
        </>
      )}
    />
  );
}
